import './pagination.scss';
import './img/next.png';
import './img/next-hov.png';
import './img/prev.png';
import './img/prev-hov.png'



// WEBPACK FOOTER //
// ./resources/views/partials/archive/pagination/pagination.js